import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useFetchIncludedFactsCount = (caseId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<number>([QueryEntity.IncludedFactsCount, { caseId }], async () => {
    try {
      const res = await fetch(`${APIBaseChronos}/api/case/${caseId}/facts/included/count`, fetchConfigGET);
      return await res.json();
    } catch (err) {
      console.error(err);
    }
  });
};
